<template>
  <div id="index" class="contentFile">
    <!-- 推荐内容 -->
    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div class="main wrap" v-else-if="is_content_power==1">
      <div class="sousuo_bg">
        <div class="sousuo_div flex_between">
          <input type="text" placeholder="请输入查找内容" name="" @keyup.enter="searchFun" v-model="search_text" id="" />
          <i @click="searchFun"><img src="@/assets/img/home/icon_cz.png" alt="" class="icon_search" /></i>
        </div>
      </div>
      <!-- 推荐 -->
      <div class="recommended">
        <div class="flex_between recommended_head">
          <div class="recommended_title">
            <span class="recommended_title_li" v-for="(liem, index) in recommended_arr" :key="index" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index)">{{ liem.title }}</span>
          </div>
        </div>
        <div class="liem_ul">
          <listContent :list_arr="list_arr" ref="listContent" :is_loading="is_loading" @detailsFun="detailsFun">
          </listContent>
          <div class="complete" v-if="is_more && list_arr.length > 0" @click="moreFun">
            点击加载更多
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-auth">
        {{no_power_msg}}
    </div>
    <!-- 尾部 -->
    <!-- <Footer></Footer> -->

    <waterBox />
  </div>
</template>

<script>
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import hot from "@/components/assembly/hot.vue"; //热门模块
import listContent from "@/components/assembly/listContent.vue"; //列表数据模块
import waterBox from "@/components/assembly/waterBox.vue";
import "@/assets/js/swiper.animate1.0.3.min.js";
// import "@/assets/js/wx_jsapi.js";
import wx from "weixin-js-sdk";

import "@/assets/js/currency.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/reset.css";

//pc端
// import "@/assets/css/index_min768.css";

export default {
  name: "column",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      recommended_id: 0, //导航 index
      recommended_arr: [], //导航列表
      recommended_index: 0, //

      page: 1, //翻页
      list_arr: [], //列表数组
      hotList_arr: [], //热门列表
      searchText: "", //搜索内容
      is_more: true,
      is_loading: false,
      idloading: true,
      search_text: "",
      is_content_power: 0,
      no_power_msg:""
    };
  },

  components: {
    HeaderTop,
    Footer,
    hot,
    listContent,
    waterBox
  },
  watch: {
    recommended_id: function (eve) {
      this.$store.commit("setColumn", eve);
      this.page = 1;
      this.getListcum();
    },
  },
  methods: {
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.header.promptShow();
      }
    },
    searchFun() {
      this.page = 1;
      this.getListcum();
    },
    follow(type) {
      //1关注2取关
      this.judgeUser();
      let that = this;
      this.$post("follow", {
        conf_id: this.recommended_id,
        member_id: this.USER().id,
        type: type,
      }).then((res) => {
        that.recommended_arr[that.recommended_index].is_follow =
          that.recommended_arr[that.recommended_index].is_follow == 1 ? 0 : 1;
      });
    },
    recommendedFun(index) {
      //切换导航
      this.recommended_id = this.recommended_arr[index].conf_id;
      this.recommended_index = index;
    },
    detailsFun(id) {
      //查看详情

      this.$router.push({
        path: "/content_details",
        query: { id: id },
      });
    },
    details(id, record_url) {
      //跳转页面
      if (this._isMobile()) {
        // alert("手机端");
        if (this.selectBox_index == 1) {
          //直播
          //   this.$router.push({path: 'min_move',query:{ id:id,url:record_url}});
        } else {
          //   this.$router.push({path: 'min_record',query:{ id:id,url:record_url}});
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          //   this.$router.push({path: 'pc_move',query:{ id:id,url:record_url}});
        } else {
          //   this.$router.push({path: 'pc_record',query:{ id:id,url:record_url}});
        }
      }
    },
    getListcum(id) {
      //获取列表数据
      let that = this;
      that.is_loading = false;

      if (this.page == 1) {
        this.list_arr = [];
      }
      this.$get("content_lists", {
        conf_id: id ? id : this.recommended_id,
        limit: 10,
        page: this.page,
        keyword: this.search_text,
        member_id: this.USER().id,
      }).then((res) => {
        console.log(res.data,'11111111')
        this.no_power_msg = res.data.power_msg;
        let arr = res.data.data.data
        if (arr.length <= 0) {
          that.is_more = false;
        } else {
          that.is_more = true;
        }
        that.list_arr = that.list_arr.concat(arr);
        console.log(this.list_arr)
        that.is_loading = true;
        this.is_content_power = res.data.is_content_power
      });
    },
    getNews() {
      //获取栏目
      this.$get("content_conf", {
        page: 1,
        limit: 999,
        member_id: this.USER().id,
      }).then((res) => {
        this.recommended_arr = res.data.data;
        this.recommended_arr.unshift({
          conf_id: 0,
          title: "全部"
        })
      });
    },
    getHotList() {
      //获取热门列表数据
      let that = this;
      this.$post("news_recomm", {
        type: 4,
        limit: 10,
        page: 1,
      }).then((res) => {
        let data = res.data.data;
        that.hotList_arr = data;
      });
    },
    moreFun() {
      this.page++;
      this.getListcum();
    },

  },
  created() {
    this.idloading = true;
    this.getListcum();
    // this.getSeo()
  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      setTimeout(() => {
        that.$refs.header.headerFun(this.searchText);
      }, 500);
    }
    document.title = "麻醉眼界";
    this.getNews();
    this.getHotList();
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getListcum();
      }
    });

  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      setTimeout(() => {
        that.$refs.header.headerFun(this.searchText);
      }, 500);
    }
    document.title = "麻醉眼界";
    if (this.$route.query.id === 0) {
      this.list_arr = [];
      this.getListcum(this.$route.query.id);
    }

    this.getNews();
    this.getHotList();


    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getListcum();
      }
    });



  },
};
</script>
<style>
</style>
<style scoped>
.sousuo_bg {
  padding: 20px;
  background: #fff;
  margin-bottom: 10px;
  border-radius: 10px;
}
.contentFile .sousuo_div {
  position: relative;
  border-radius: 20px;
  background: #e5e5e5;
  height: 40px;
  padding: 0 4px 0 10px;
  width: 50%;
  margin: 0 auto;
}

.contentFile .sousuo_div > i {
  position: absolute;
  right: 10px;
  width: 24px;
  height: 24px;
}
.icon_search {
  width: 16px;
  height: 16px;
}

.contentFile .sousuo_div > input {
  flex: 1;
  margin-right: 10px;
  font-size: 15px;
  border: 0;
  height: 100%;
  padding-left: 10px;
}

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes configure-clockwise {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@keyframes configure-xclockwise {
  0% {
    transform: rotate(45deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-135deg);
  }
  75% {
    transform: rotate(-215deg);
  }
  100% {
    transform: rotate(-305deg);
  }
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.25;
    transform: scale(0.75);
  }
}

/* GRID STYLING */

* {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  background-color: #37474f;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}

.spinner-box {
  width: 100%;
  height: 90vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.spinner-box div {
  margin-top: 10px;
  font-size: 20px;
}
/* SPINNING CIRCLE */

.circle-border {
  width: 150px;
  height: 150px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgb(63, 249, 220);
  background: linear-gradient(
    0deg,
    rgba(63, 249, 220, 0.1) 33%,
    rgba(63, 249, 220, 1) 100%
  );
  animation: spin 0.8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
  border-radius: 50%;
}

/* X-ROTATING BOXES */

.configure-border-1 {
  width: 115px;
  height: 115px;
  padding: 3px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffab91;
  animation: configure-clockwise 3s ease-in-out 0s infinite alternate;
}

.configure-border-2 {
  width: 115px;
  height: 115px;
  padding: 3px;
  left: -115px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(63, 249, 220);
  transform: rotate(45deg);
  animation: configure-xclockwise 3s ease-in-out 0s infinite alternate;
}

.configure-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
}

/* PULSE BUBBLES */

.pulse-container {
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.pulse-bubble-1 {
  animation: pulse 0.4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
  animation: pulse 0.4s ease 0.2s infinite alternate;
}
.pulse-bubble-3 {
  animation: pulse 0.4s ease 0.4s infinite alternate;
}

/* SOLAR SYSTEM */

.solar-system {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orbit {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffffa5;
  border-radius: 50%;
}

.earth-orbit {
  width: 165px;
  height: 165px;
  -webkit-animation: spin 12s linear 0s infinite;
}

.venus-orbit {
  width: 120px;
  height: 120px;
  -webkit-animation: spin 7.4s linear 0s infinite;
}

.mercury-orbit {
  width: 90px;
  height: 90px;
  -webkit-animation: spin 3s linear 0s infinite;
}

.planet {
  position: absolute;
  top: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.sun {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #ffab91;
}
.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  width: 1280px;
  position: relative;
}

#index {
  background: #f5f3fb;
  min-width: 1280px;
}

.main {
  padding: 13px 0;
}

/* 推荐导航 */
.recommended {
  width: 100%;
  background: #fff;
  border-radius: 10px;
}

.recommended .recommended_head {
  padding: 8px 20px 0 20px;
  border-bottom: 0.005rem solid #999999;
  white-space: normal;
  align-items: flex-start;
}

.recommended .recommended_head .recommended_title {
  flex: 1;
}

.recommended .recommended_title .recommended_title_li {
  margin-right: 6px;
  width: 18%;
  margin-bottom: 6px;
  font-size: 15px;
  cursor: pointer;
  color: #333;
  display: inline-flex;
}

.recommended .recommended_title .recommended_title_li.selected {
  position: relative;
  font-weight: bold;
}

.recommended .recommended_title .recommended_title_li.selected {
  color: #f24d5b;
  font-weight: bold;
}

.recommended .recommended_head .focus {
  width: 108px;
  height: 34px;
  border-radius: 4px;
  color: #fff;
  background: #f24d5b;
  font-size: 14px;
  border: 0;
}

.recommended .recommended_head .focus.no_focus {
  background: #ccc;
}

.liem_ul {
  padding-bottom: 40px;
  /* max-height: 100vh;
        overflow-y:auto; */
}

/* 热门 */
.hot {
  width: 334px;
  background: #fff;
  border-radius: 10px;
  /* position: fixed;
        right: calc((100% - 1280px) / 2);
        top: 74px; */
  position: absolute;
  right: 0;
  top: 13px;
}

.hot .hot_title {
  border-bottom: 0.005rem solid #999999;
}

.hot .hot_title > i {
  width: 15px;
  margin-right: 11px;
}

.hot .hot_title > span {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  height: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/contentFile.vue